import {
	StoreAsyncItem,
	createReducer,
	createAsyncInitialState,
	checkAsyncAction
} from '@flux';
import { contextActionsPack } from '../actions';


export type ContextState = {} & StoreAsyncItem<ClientSessionContext>;

const initialState = createAsyncInitialState<ClientSessionContext>() as ContextState;

const contextReducer = createReducer(initialState, {
	[contextActionsPack.types.FETCH_SESSION_CONTEXT]: (action, state) => {
		return checkAsyncAction<ClientSessionContext>(action, state);
	},
	[contextActionsPack.types.LOGOUT]: (action, state) => {
		return checkAsyncAction(action, state);
	}
});


export {
	contextReducer
}
